import { IBlobInfo } from "../../Interfaces/base/IBase";
import { fetchListVerificacion } from "../http-common";

const getFileByBlob = (blobInfo: IBlobInfo) => {
  return fetchListVerificacion.post(`Blob/ObtenerArchivo`, blobInfo);
};

export const BlobService = { getFileByBlob };
